
import { useSelector } from 'react-redux';
import { useCallback, useRef, useEffect } from 'react';
import { getUserId, getDisplayName } from '@store/features';
import { logEvent, logWarn } from '@api/Logging';

export const useLoggingServices = () => {
  const baseUrl = window.location.origin;
  const userId = useSelector(getUserId);
  const displayName = useSelector(getDisplayName);

  const userIdRef = useRef(userId);
  const displayNameRef = useRef(displayName);
  useEffect(() => { userIdRef.current = userId; }, [userId]);
  useEffect(() => { displayNameRef.current = displayName; }, [displayName]);

  const logPageChange = useCallback((path, properties) => {
    const currentUserId = userIdRef.current;
    if (!currentUserId) {
      logWarn('No logged in user was identified.');
      return;
    }

    const timeStamp = new Date().toISOString();
    const message = `User request (endpoint, fingerprint, userid, timestamp, parameters, origin): ${path},,${currentUserId},${timeStamp},,${baseUrl}`;

    logEvent(message, undefined, { ...properties, userId: currentUserId, userName: displayNameRef.current, path });
  }, [baseUrl]);

  return {
    logPageChange
  };
};
